import { useEffect, useState } from 'react';
import { clientService } from '../../services/clientService';
import { typesService } from '../../services/typesService';
import { ClientOption, ModelOption } from './firmwareForm';

/**
 * The dropdown options of the firmware dialogs: every model reference of
 * the catalogue (with its gateway type) and the active clients. Loaded when
 * the dialog opens; a failed load leaves the list empty and logs a warning.
 */
export const useFirmwareOptions = (enabled: boolean) => {
  const [models, setModels] = useState<ModelOption[]>([]);
  const [clients, setClients] = useState<ClientOption[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      try {
        const list = await clientService.fetchActiveClients();
        if (!cancelled) setClients(list);
      } catch {
        console.warn('[FIRMWARE] Could not fetch clients');
      }
      try {
        const types = await typesService.getHardwareTypes(false);
        const refsByType = await Promise.all(types.map((type) => typesService.getModelReferences(type.id, false)));
        if (!cancelled) {
          setModels(types.flatMap((type, i) => refsByType[i].map((ref) => ({ code: ref.code, name: ref.name || ref.code, hardwareType: type.code }))));
        }
      } catch {
        console.warn('[FIRMWARE] Could not fetch model references');
      }
    })();
    return () => { cancelled = true; };
  }, [enabled]);

  return { models, clients };
};
